import { apiSlice } from '../apiSlice'

export const userApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    logIn: builder.mutation({
      query: (data) => ({
        url: '/auth/login',
        method: 'POST',
        body: data,
      }),
    }),
    signUp: builder.mutation({
      query: (data) => ({
        url: '/users/register',
        method: 'POST',
        body: data,
      }),

      invalidatesTags: (result, error, { id }) => [{ type: 'users' }],
    }),
    accountVerification: builder.mutation({
      query: (token) => ({
        url: `/users/register/verify-email?token=${token}`,
        method: 'GET',
      }),
    }),
    getAllUser: builder.query({
      query: () => `/users`,
      providesTags: (result) =>
        result
          ? [
              ...result.map((user) => ({ type: 'user', id: user.id })),
              { type: 'users' },
            ]
          : [{ type: 'users' }],
    }),
    getUserById: builder.query({
      query: (userId) => `users/user/${userId}`,
      providesTags: (result, error, userId) => [{ type: 'user', id: userId }],
    }),
    resetPassword: builder.mutation({
      query: (data) => ({
        url: '/users/reset-password',
        method: 'POST',
        body: data,
      }),
    }),
    updatePassword: builder.mutation({
      query: ({ data, token }) => ({
        url: `/users/update-password?token=${token}`,
        method: 'POST',
        body: data,
      }),
    }),
    updateUserDetails: builder.mutation({
      query: (data) => ({
        url: `/users/admin/update-user`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'users' },
        { type: 'user', id },
      ],
    }),
    deleteUserAccount: builder.mutation({
      query: (email) => ({
        url: `/users/admin/${email}`,
        method: 'DELETE',
      }),
      invalidatesTags: () => [{ type: 'users' }],
    }),
  }),
})
export const {
  useLogInMutation,
  useSignUpMutation,
  useGetAllUserQuery,
  useGetUserByIdQuery,
  useResetPasswordMutation,
  useUpdatePasswordMutation,
  useUpdateUserDetailsMutation,
  useDeleteUserAccountMutation,
  useAccountVerificationMutation,
} = userApi
